import ProductApiHandler from 'lib/api/product'
import { SEGMENT_STORAGE_KEY_PROMPT_LOCATION } from 'lib/segment/const'
import { segmentSignInViewed } from 'lib/segment'
import authDuck from 'components/auth/duck'

function useAddToWaitlist({
  onError = () => null,
  onSuccess = () => null,
  product = null,
  sizeData = null,
}) {
  return async (dispatch, getState) => {
    const { auth } = getState()

    if (!auth?.token) {
      const promptLocation = 'notify_me'
      segmentSignInViewed(promptLocation)
      sessionStorage.setItem(
        SEGMENT_STORAGE_KEY_PROMPT_LOCATION,
        promptLocation,
      )
      await dispatch(authDuck.creators.updateShowLogin(true))
      onError(false)
      return false
    }

    try {
      await ProductApiHandler.addToWaitList({
        product_id: product.id_product,
        product_attribute_id: sizeData.id_product_attribute,
      })

      onSuccess(null, sizeData.id_product_attribute)
      return null
    } catch (err) {
      onError(err)
      return err
    }
  }
}

export default useAddToWaitlist
